<template>
    <div class="wrapper">
        <div style="font-size: 20px">
            {{ editing_tag_name }}
        </div>
        <div style="margin:30px 0 10px 0; font-size: 16px">
            <span v-show="is_selected">サブタグを設定</span>
        </div>
        <div>
            <transition-group name="flip">
                <md-chip
                    md-clickable
                    class="chip"
                    v-for="sub_tag in editing_tag_sub_tags"
                    :class='{"md-accent selected-tag": sub_tag.is_child}'
                    :key="sub_tag.id"
                    @click="click_sub_tag(sub_tag.id)"
                    >
                    {{ sub_tag.name }}
                </md-chip>
            </transition-group>
        </div>
    </div>
</template>

<script>
export default {
name: 'TagEditContainer',
data: () => ({
    active: false,
}),
methods: {
    click_sub_tag (sub_tag_id) {
        console.log('click_sub_tag')
        this.$store.dispatch('tags/update_editing_tag_children', sub_tag_id)
    },
},
computed: {
    editing_tag_name() {
        if (this.$store.getters['tags/editing_tag'] == '') {
            return 'サイドバーからタグを選択して下さい'
        }
        return this.$store.getters['tags/editing_tag'].name
    },
    editing_tag_sub_tags () {
        return this.$store.getters['tags/editing_tag_sub_tags']
    },
    is_selected() {
      return this.$store.getters['tags/editing_tag'] != ''
    },
},
}
</script>

<style lang="scss" scoped>
.wrapper {
    text-align: left;
    padding: 20px;
}
.flip {
  // 要素が移動するときのアニメーション設定（基本的にはtransitionにtransformを設定していればいい）
  &-move {
    transition: transform 0.5s;
  }

  // 要素が入るときのアニメーション
  &-enter {
    // アニメーションの初期設定（初期値とtransitionを設定する）
    &-active {
      opacity: 0;
      transform: translate3d(0, -30px, 0);
      transition: opacity 0.5s, transform 0.5s;
    }
    // アニメーション開始（目標のプロパティ値を設定する）
    &-to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  // 要素が消える時のアニメーション
  &-leave {
    // アニメーションの初期設定
    &-active {
      // 要素が消える場合はabsoluteにする（重要！）
      position: absolute;
      transition: opacity 0.5s, transform 0.5s;
    }
    // アニメーション開始
    &-to {
      opacity: 0;
      transform: translate3d(0, -30px, 0);
    }
  }
}

.selected-tag {
	color: aliceblue !important;
	font-weight: bold;
}
.selected-tag:hover {
    background-color: #6EBD91 !important;
}
.selected-tag-count {
	color: rgba(0, 0, 0, 0.87);
	font-weight: 100;
}
.chip {
	height: 28px;
	line-height: 28px;
	margin-bottom: 12px;

}
</style>
